module.exports = __webpack_public_path__ + "img/mulher-ranking.18ddb9c0.png";